import React from 'react';
import HeroSection from './heroSection';
import { FeaturedStoreSection } from './featuredStoreSection';
import { DiscoverSection } from './discoverClosetSection';
import { ShowcaseSection } from './ctaSection';
import { NewsletterSection } from './newsletterSection';

export const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <FeaturedStoreSection />
      <DiscoverSection />
      <ShowcaseSection />
      <NewsletterSection />
    </main>
  );
};
